import { useCallback, useEffect, useState } from 'react'
import debugConstructor from 'debug'

import { useUsercentrics } from 'utils/commonHooks'
import { isWebViewRoute } from 'utils/router/tools'

const debug = debugConstructor('wootric')

export const USERCENTRICS_WOOTRIC_NAME = 'Wootric'

interface UseWootrikHook {
  sendWootricEvent: (eventName: string) => void
  isReady: boolean
}

export const useWootric = (): UseWootrikHook => {
  const { usercentricsServicesInfo } = useUsercentrics(USERCENTRICS_WOOTRIC_NAME)

  const isProvideWootric = usercentricsServicesInfo[USERCENTRICS_WOOTRIC_NAME]?.status ?? false
  const isInitializedWootric = Boolean(window.wootric)
  const isWootricSettings = Boolean(window.wootricSettings)

  const [isReady, setIsReady] = useState(
    isProvideWootric && isInitializedWootric && isWootricSettings,
  )

  const handleLoad = useCallback(() => {
    if (!window.wootric) {
      return
    }
    setIsReady(true)
  }, [])

  const sendWootricEvent = useCallback((eventName: string) => {
    if (typeof window.wootric === 'function') {
      window.wootric(eventName)
    } else {
      debug('wootricTrigger', eventName)
    }
  }, [])

  const skipInitialization =
    !isProvideWootric || isInitializedWootric || !isWootricSettings || isWebViewRoute()
  useEffect(() => {
    if (skipInitialization) {
      return
    }

    const script = document.createElement('script')
    script.src = `https://cdn.wootric.com/wootric-sdk.js`
    script.async = true
    script.onload = handleLoad
    document.head.appendChild(script)
  }, [handleLoad, skipInitialization])

  return { sendWootricEvent, isReady }
}
